import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=6babbb16&scoped=true&"
import script from "./recordList.vue?vue&type=script&lang=ts&"
export * from "./recordList.vue?vue&type=script&lang=ts&"
import style0 from "./recordList.vue?vue&type=style&index=0&id=6babbb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6babbb16",
  null
  
)

export default component.exports